import { Mapview } from '@pages/Mapview';
import { Admin } from '@pages/Admin';
import { Login } from '@pages/Login';
import { Router, Route, Routes } from './react-router';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import React from 'react';
import { Register } from 'pages/Register';
import { Navigation } from 'components/Navigation';
import { store } from './src/store';
import { Provider } from 'react-redux';

export default function App() {
  const { height, width } = useWindowDimensions();

  return (
    <Provider store={store}>
      <Router>
        <View style={[styles.container, { width, height }]}>
          <Navigation />
          <Routes>
            <Route path="/" element={<Mapview />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </View>
      </Router>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
